import React from "react";
import { HelpCircle } from "lucide-react";
import { useClara } from "../contexts/ClaraContext";

export const HelpButton = ({ helpText, testId = "screen-help-btn" }) => {
    const { speak } = useClara();

    if (!helpText) return null;

    const handle = () => {
        speak(helpText);
    };

    return (
        <button
            type="button"
            onClick={handle}
            aria-label="What can I do here? Clara will explain this screen."
            data-testid={testId}
            className="inline-flex items-center justify-center min-w-[44px] min-h-[44px] rounded-xl bg-white border-2 border-[#0A3D7A] text-[#0A3D7A] hover:bg-[#0A3D7A] hover:text-white transition-colors"
        >
            <HelpCircle className="w-5 h-5" strokeWidth={2.3} />
        </button>
    );
};

export default HelpButton;
